module.exports = __webpack_public_path__ + "plugins/jquery.loader/img/jquery.loader.gif";


//////////////////
// WEBPACK FOOTER
// ./plugins/jquery.loader/img/jquery.loader.gif
// module id = 156
// module chunks = 2 3 7 8 11 20 21 22 39 40 42 43 44 45 46 47 49